var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4667 14.4375V18.375H2.53333V14.4375H0V19.6875C0 20.4135 0.567625 21 1.26667 21H17.7333C18.434 21 19 20.4135 19 19.6875V14.4375H16.4667Z",
    fill: "#ABDFCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3962 6.37389C14.2905 6.61637 14.0577 6.77083 13.8016 6.77083H11.1878V15.5729C11.1878 15.9466 10.895 16.25 10.5344 16.25H7.92064C7.56002 16.25 7.2672 15.9466 7.2672 15.5729V6.77083H4.65344C4.39738 6.77083 4.16459 6.6151 4.05881 6.37389C3.95181 6.13141 3.99347 5.84831 4.16214 5.64814L8.73622 0.231478C8.86037 0.0837898 9.03925 0 9.22752 0C9.41579 0 9.59467 0.0854816 9.71882 0.231478L14.2929 5.64814C14.4628 5.84746 14.502 6.13184 14.3962 6.37389Z",
    fill: "#ABDFCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6b7ee87d4330c5779cd4ec371c7f0da6.svg";
export { ForwardRef as ReactComponent };